export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const getUniqueArray = (arr = [], key = "_id") => {
    if (!Array.isArray(arr)) return [];
    return Array.from(new Map(arr.map((item) => [item[key], item])).values());
  };